/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_TitleInputs */

const tr_mesafeli_title = /** @type {(inputs: Mesafeli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesafeli Hizmet Sözleşmesi`)
};

const en_mesafeli_title = /** @type {(inputs: Mesafeli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance Service Agreement`)
};

const de_mesafeli_title = /** @type {(inputs: Mesafeli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fernabsatz-Dienstleistungsvertrag`)
};

const ru_mesafeli_title = /** @type {(inputs: Mesafeli_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Договор дистанционного оказания услуг`)
};

/**
* | output |
* | --- |
* | "Distance Service Agreement" |
*
* @param {Mesafeli_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_title = /** @type {((inputs?: Mesafeli_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_title(inputs)
	if (locale === "de") return de_mesafeli_title(inputs)
	if (locale === "ru") return ru_mesafeli_title(inputs)
	return tr_mesafeli_title(inputs)
});